import React from "react";
import PropTypes from "prop-types";
import { useDeviceDetect } from "hooks";
import WizardCardMobile from "./mobile";
import WizardCardDesktop from "./desktop";

const WizardCard = ({ title, text, diagnosisType, visitType, wizardButtonText, readMoreUrl, readMoreText, squareSymbolUrl, wideSymbolUrl, symbolAlt, mascotUrl, mascotAlt }) => {
    const { isSmallScreen } = useDeviceDetect(992);

    if (isSmallScreen) {
        return <WizardCardMobile
            title={title}
            text={text}
            diagnosisType={diagnosisType}
            visitType={visitType}
            wizardButtonText={wizardButtonText}
            readMoreUrl={readMoreUrl}
            readMoreText={readMoreText}
            symbolUrl={wideSymbolUrl}
            symbolAlt={symbolAlt}
            mascotUrl={mascotUrl}
            mascotAlt={mascotAlt}
        />
    }

    return <WizardCardDesktop
        title={title} text={text}
        diagnosisType={diagnosisType}
        visitType={visitType}
        wizardButtonText={wizardButtonText}
        readMoreUrl={readMoreUrl}
        readMoreText={readMoreText}
        symbolUrl={squareSymbolUrl}
        symbolAlt={symbolAlt}
        mascotUrl={mascotUrl}
        mascotAlt={mascotAlt}
    />
};

WizardCard.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    diagnosisType: PropTypes.string.isRequired,
    visitType: PropTypes.string.isRequired,
    wizardButtonText: PropTypes.string.isRequired,
    readMoreUrl: PropTypes.string.isRequired,
    readMoreText: PropTypes.string.isRequired,
    squareSymbolUrl: PropTypes.string.isRequired,
    wideSymbolUrl: PropTypes.string.isRequired,
    symbolAlt: PropTypes.string.isRequired,
    mascotUrl: PropTypes.string.isRequired,
    mascotAlt: PropTypes.string.isRequired,
};

export default WizardCard;
